import React from 'react'
import theme from 'redesign/themes/main'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const AddIcon: React.FC<IconProps> = ({
  color = theme.palette.error.main,
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
  fillOpacity,
}) => (
  <SvgWrapper aria-label="Add" size={size} viewBox={viewBox} fill="none">
    <path
      d="M11.2222 18.2222v-5.4444H5.77778C5.34822 12.7778 5 12.4296 5 12c0-.4296.34822-.7778.77778-.7778h5.44442V5.77778C11.2222 5.34822 11.5704 5 12 5c.4296 0 .7778.34822.7778.77778v5.44442h5.4444c.4296 0 .7778.3482.7778.7778 0 .4296-.3482.7778-.7778.7778h-5.4444v5.4444c0 .4296-.3482.7778-.7778.7778-.4296 0-.7778-.3482-.7778-.7778Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  </SvgWrapper>
)

export default AddIcon
